import { merge } from 'lodash';
import VueI18n from 'vue-i18n';

import { fetchLocale } from './fetch-locale';
import { dateTimeFormats, messages } from './locales';

let instance: VueI18n = null as any;

export function createInstance(msgs = messages, locale = 'fr') {
    return new VueI18n({
        dateTimeFormats,
        fallbackLocale: 'fr',
        locale,
        messages: msgs,
    });
}

export async function i18n() {
    if (instance) {
        return instance;
    }

    const locale = localStorage.getItem('locale') || navigator.language.split('-')[0] || 'fr';
    let remoteMessages = {};

    try {
        remoteMessages = await fetchLocale(locale);
    } catch (error) {
        // tslint:disable-next-line:no-console
        console.error(error);
    }

    instance = createInstance(merge(remoteMessages, messages), locale);

    return instance;
}
